<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper" style="margin-bottom: -200px;">
      <el-menu :default-openeds="defaultOpenedsArr" :default-active="activeMenu" :collapse="isCollapse"
        :background-color="variables.menuBg" :text-color="variables.menuText" :unique-opened="false"
        :active-text-color="variables.menuActiveText" :collapse-transition="false" mode="vertical">
        <sidebar-item v-for="route in routesArr" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Logo from './Logo'
  import SidebarItem from './SidebarItem'
  import variables from '@/styles/variables.scss'
  import { webMenu } from "@/api/user.js"

  export default {
    components: { SidebarItem, Logo },
    data() {
      return {
        routesArr: [],
        // 默认打开四级菜单的三级菜单路由
        defaultOpenedsArr: ['/assistant/weekPlan', '/assistant/fullYearPlan', '/assistant/multiYearPlan',
          '/trainPlan/View',
          '/trainPlan/fullYearPlanView', '/trainPlan/winterPeriodPlanView', '/medical/assessmentReport',
          '/science/selection/testReport',
          '/medical/filterReport', '/medical/monitorReport',
        ]
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ]),
      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
      showLogo() {
        return this.$store.state.settings.sidebarLogo
      },
      variables() {
        return variables
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    created() {
      this.getSidebar()
    },
    watch: {
      $route(to, from) {
        this.getSidebar()
      },
    },
    methods: {
      getSidebar() {
        let menu = JSON.parse(window.localStorage.getItem('menu'))
        if (!menu) {
          this.$store.dispatch('user/logout')
          this.$router.push(`/login`)
          return
        }
        let menu34 = menu.menu34
        let currentMenu = webMenu()
        if (currentMenu) {
          let routes = this.$router.options.routes
          let arr = []
          let sysMenu = []
          menu34.forEach(item => {
            sysMenu.push(item.url)
          })
          routes.forEach((item, index) => {
            if (currentMenu.indexOf(item.path) > -1 && sysMenu.indexOf(item.path) > -1) {
              arr.push(item)
            }
          })
          this.routesArr = arr
        }
      },
    },
    beforeDestroy() {
      window.localStorage.removeItem('path')
    }
  }
</script>
